<template>
  <div>
    <div class="live-box">
      <div class="live-head">
        <img src="@img/back.png" @click="toback" class="back" alt />
        <p class="title">{{name}}</p>
        <div class="views">
          <img src="@img/popular.png" alt />
          <span>{{num}}</span>
        </div>
      </div>
      <div class="live-main">
        <div class="player">
          <LivePlayer />
        </div>
        <div class="chat">
          <div class="ann">
            <img src="@img/info.png" alt />
            <div class="ann-less" @mouseenter="showAnn">{{ann}}</div>
          </div>
          <div class="mores" v-if="annShow" @mouseleave="closeAnn">
            <img src="@img/info.png" alt />
            {{ann}}
          </div>
          <div class="comment" id="comment">
            <p v-for="(item, index) in commentList" :key="index">
              <span class="user">{{item.nickName}}：</span>
              <span>{{item.content}}</span>
            </p>
          </div>
          <div class="submit">
            <div class="emoji">
              <img :src="showflower" @mouseenter="enter" @mouseleave="leave" @click="roseAdd" alt />
            </div>
            <div class="input">
              <a-textarea
                :placeholder="basic"
                :disabled="dis"
                class="text"
                @keyup.enter="submitChat"
                v-model="val"
              />
              <a-button type="primary" class="input-btn" @click="submitChat">发送</a-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LivePlayer from "./components/LivePlayer";
import { apiGetLiveChat } from "@/api/live";
export default {
  name: "liveroom",
  components: {
    LivePlayer
  },
  data() {
    return {
      source: "",
      val: "",
      websocket: null,
      userList: "",
      _params: "",
      commentList: [],
      rose: "🌹",
      showflower: "",
      flower: require("@img/flower.png"),
      flower_hover: require("@img/flower_hover.png"),
      ann: "",
      basic: "",
      dis: false,
      num: "",
      name: "",
      annShow: false
    };
  },
  beforeMount() {
    this.getLiveChat();
    this.showflower = this.flower;
    this.name = this.$route.query.name;
  },
  destroyed() {
    let that = this;
    that.testSokectState(function() {
      that.websocket.close();
    });
  },
  methods: {
    showAnn() {
      this.annShow = !this.annShow;
    },
    closeAnn() {
      this.annShow = !this.annShow;
    },
    enter() {
      this.showflower = this.flower_hover;
    },
    leave() {
      this.showflower = this.flower;
    },
    roseAdd() {
      this.val = this.val + this.rose;
    },
    initWebSocket() {
      this.websocket.onmessage = this.onmessage;
      this.websocket.onopen = this.onopen;
      this.websocket.onerror = this.onerror;
      this.websocket.onclose = this.close;
    },
    toback() {
      let that = this;
      that.$router.push({
        path: "/page/course_details",
        query: {
          course_id: that.$route.query.id,
          course_type: that.$route.query.course_type
        }
      });
    },
    scrollToBottom() {
      let that = this;
      that.$nextTick(() => {
          var container = that.$el.querySelector("#comment");
          container.scrollTop = container.scrollHeight;
      });
    },
    onmessage(e) {
      console.log("message: ", e); //打印出服务端返回过来的数据
      let data = JSON.parse(e.data);
      switch (data.cmd) {
        case "Room_Users":
          console.log("房间成员列表");
          this.userList = data.userList;
          console.log(userList, "userList");
          break;
        case "MESSAGE":
          if (this.commentList.length > 49) {
            this.commentList.shift();
            this.commentList.push({
              nickName: data.userInfo.nickName,
              content: data.content
            });
          } else {
            this.commentList.push({
              nickName: data.userInfo.nickName,
              content: data.content
            });
          }
          this.scrollToBottom();
          break;
        case "Broadcast_Message":
          this.ann = data.content;
          break;
        case "Join_Room":
          console.log(data);
          this.ann = data.notice;
          if (data.forbid_status == 1) {
            this.basic = "您已被管理员禁言";
            this.dis = true;
          }
          if (data.room_forbid_status == 1) {
            this.basic = "管理员已开启全员禁言";
            this.dis = true;
          }
          let oldMessage = data.oldMessage;
          if(oldMessage.length > 0){
            this.commentList = oldMessage.map(item => {
              return {
                nickName: item.userInfo.nickName,
                content: item.content
              }
            });
            this.scrollToBottom();
          }
          break;
        case "Forbidden_User":
          this.basic = "您已被管理员禁言";
          this.dis = true;
          break;
        case "Forbidden_Room":
          this.basic = "管理员已开启全员禁言";
          this.dis = true;
          break;
        case "Forbidden_Room_Cancel":
          this.basic = "";
          this.dis = false;
          break;
        case "Forbidden_User_Cancel":
          this.basic = "";
          this.dis = false;
          break;
        case "User_Num_Change":
          console.log("设计师");
          this.num = data.num;
          break;
        default:
          break;
      }
    },
    onopen() {
      console.log("WebSocket open"); //成功连接上Websocket
      this.sendMessage({
        cmd: "Join_Room"
      });
    },
    onclose(e) {
      console.log("你已离开房间");
    },
    onerror(e) {
      console.log("聊天服务出错：", e);
    },
    getLiveChat() {
      return new Promise((resolve, reject) => {
        apiGetLiveChat({ course_id: this.$route.query.id })
          .then(res => {
            this._params = res.result;
            console.log(this._params.serviceUrl);
            if ("WebSocket" in window) {
              this.websocket = new WebSocket(this._params.serviceUrl);
              // this.websocket = new WebSocket("ws://192.168.1.80:3000");
              this.initWebSocket();
            } else {
              alert("当前浏览器 Not support websocket");
            }
          })
          .catch(reeor => {});
      });
    },
    sendMessage(params) {
      let _params = this._params;
      let newParams = {};
      newParams = this.ex(newParams, _params, params);
      console.log(newParams);
      //通过websocket发送数据
      this.websocket.send(JSON.stringify(newParams));
    },
    ex() {
      let length = arguments.length;
      let target = arguments[0] || {};
      if (typeof target != "object" && typeof target != "function") {
        target = {};
      }
      if (length == 1) {
        target = this;
        i--;
      }
      for (let i = 1; i < length; i++) {
        let source = arguments[i];
        for (let key in source) {
          // 使用for in会遍历数组所有的可枚举属性，包括原型。
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    },
    submitChat() {
      let that = this;
      if (this.val) {
        that.testSokectState(function() {
          that.sendMessage({
            cmd: "Send_Message",
            content: that.val
          });
          console.log("已发送");
        });
        this.val = "";
      }
    },
    testSokectState(cb) {
      let that = this;
      /**
       * readyState
       * 0 - 表示连接尚未建立。
       * 1 - 表示连接已建立，可以进行通信。
       * 2 - 表示连接正在进行关闭。
       * 3 - 表示连接已经关闭或者连接不能打开。
       * */
      if (this.websocket == undefined) {
        console.log("您还未加入房间");
        return false;
      } else {
        var state = this.websocket.readyState;
        if (state == 0) {
          console.log("您还未加入房间");
          return false;
        } else if (state == 1) {
          cb();
          return true;
        } else if (state == 2) {
          console.log("正在退出房间");
          return false;
        } else if (state == 3) {
          console.log("您已经退出房间");
          this.websocket.close();
          this.websocket = new WebSocket(that._params.serviceUrl);
          // this.websocket = new WebSocket("ws://192.168.1.80:3000");
          this.initWebSocket();
          cb();
          return false;
        } else {
          return false;
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.live-box {
  padding: 20px;
  margin: 0 auto;
  width: 1180px;
  min-height: 600px;
  .live-head {
    width: 100%;
    height: 64px;
    display: flex;
    align-items: center;
    background: #fff;
    border: 1px solid #e6e6e6;
    .back {
      width: 24px;
      height: 24px;
      margin-right: 10px;
      margin-left: 20px;
      cursor: pointer;
    }
    p {
      margin: 0;
    }
    .views {
      display: flex;
      align-items: center;
      span {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #4d4d4d;
        letter-spacing: 0;
      }
      img {
        width: 18px;
        height: 18px;
        margin-right: 5px;
      }
    }
    .title {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #4d4d4d;
      letter-spacing: 0;
      margin-right: 26px;
    }
  }
  .live-main {
    width: 100%;
    height: 536px;
    display: flex;
    border: 1px solid #e6e6e6;
    border-top: none;
    .player {
      width: 880px;
      height: 536px;
    }
    .chat {
      width: 300px;
      background: #fff;
      position: relative;
      height: 100%;
      .ann {
        padding-left: 17px;
        position: relative;
        height: 39px;
        border-bottom: 1px solid #e6e6e6;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #999999;
        letter-spacing: 0;
        line-height: 20px;
        display: flex;
        align-items: center;
        img {
          margin-right: 5px;
          width: 18px;
          height: 16px;
        }
        .ann-less {
          height: 18px;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .mores {
        min-height: 100px;
        width: 300px;
        padding-left: 17px;
        position: absolute;
        border-bottom: 1px solid #e6e6e6;
        top: 0;
        left: 0;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #999999;
        letter-spacing: 0;
        line-height: 20px;
        z-index: 888;
        background: #ffffff;
        padding: 10px 16px;
        word-break:break-all;
        img {
          margin-right: 5px;
          width: 18px;
          height: 16px;
        }
      }
      .comment {
        padding: 16px;
        box-sizing: border-box;
        height: 383px;
        word-break:break-all;
        overflow-y:auto;
        background: #f8f9fa;
        border-bottom: 1px solid #e6e6e6;
        .user {
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #3b9dff;
          letter-spacing: 0;
        }
      }
      .submit {
        height: 112px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .emoji {
          margin-top: 10px;
          padding-left: 10px;
          display: flex;
          align-items: center;
          width: 100%;
          height: 18px;
          img {
            cursor: pointer;
            width: 14px;
            height: 18px;
          }
        }
        .input {
          margin-top: 10px;
          width: 278px;
          display: flex;
          height: 60px;
          .text {
            flex: 4;
            height: 100%;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            resize: none;
          }
          .input-btn {
            flex: 1;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>

